module.exports = __webpack_public_path__ + "static/security4-3628fdb6e6bd91007eb81d0f1535045a.png";